import React from "react";
import PropTypes from "prop-types";

import ParticularUserData from "../ParticularUserData";
import { Box, Modal } from "@mui/material";

const OrganizationModal = ({
  open,
  handleClose,
  userDetail,
  initialData = []
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="bg-white p-6 rounded-lg w-[90%] max-w-4xl mx-auto mt-20 ">
        <h4 className="text-xl flex justify-center  font-semibold mb-4">Organizations</h4>
        <ParticularUserData userDetail={userDetail} />
        <button className="mt-4 btn btn-secondary" onClick={handleClose}>
          Close
        </button>
      </Box>
    </Modal>
  );
};

OrganizationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  initialData: PropTypes.array
};

export default OrganizationModal;
